import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import { GameEvent } from '../GameAbstract';
import GameAbstract from '../GameAbstract';

export default class ComponentAbstract extends AbstractDispatcher {

    protected _resizeHandler             : Function;
    protected _elComponent               : HTMLElement;
    protected _pixi                      : PIXI.Application = GameAbstract.instance.pixi;

    constructor() {
        super();
        this._resizeHandler = this._resize.bind(this);
        GameAbstract.instance.addListener(GameEvent.RESIZE, this._resizeHandler);
    };

    
    /*
     * destroy - destroy this instance
     * 
     */
    public destroy() {
        GameAbstract.instance.removeListener(GameEvent.RESIZE, this._resizeHandler);

        if (typeof this._elComponent !== 'undefined') {
            this._elComponent.parentNode.removeChild(this._elComponent);
        }
    };


    /*
     * GET component - returns component HTML ELement
     * 
     */
    public get el(): any { return this._elComponent; }


    /*
     * _resize - handle resize
     * 
     */
    protected _resize(e) {
        
    }

}

export class CountdownEvent {
    public static COMPLETE              : string                = 'complete';
}